import {useCallback, useEffect} from "react";
import {useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";


export default function useReverseMatcherBrandSkus(brandID, siteID, excluded) {
	const isLoading = useSignal(false)
	const searchText = useSignal('')
	const brandsOptions = useSignal([])

	// AbortController of the latest in-flight request; only the most recent request may mutate
	// state, so a late-resolving superseded/aborted request can't overwrite the new candidates.
	const controller = useSignal(null)

	useEffect(() => {
		return () => {
			if (controller.value) {
				controller.value.abort()
				controller.value = null
			}
		}
	}, [])

	const loadBrandSkus = useCallback(() => {
		if (!brandID || !siteID) return

		if (controller.value) controller.value.abort()
		const myController = new AbortController()
		controller.value = myController

		isLoading.value = true
		postSubmit(`${BACKEND_APIS.MATCHERS}/selectors/sku-mapping/${brandID}/${siteID}`, {
			find: searchText.value
		}, { signal: myController.signal }).then(res => {
			if (controller.value !== myController) return
			controller.value = null
			isLoading.value = false
			brandsOptions.value = res.options
		}).catch(() => {
			if (controller.value !== myController) return
			controller.value = null
			isLoading.value = false
		})
	}, [brandID, siteID, searchText.value])

	// Clear candidates when the brand/site changes so the previous product's candidates don't linger.
	useEffect(() => {
		brandsOptions.value = []
	}, [brandID, siteID])

	useEffect(() => {
		loadBrandSkus()
	}, [brandID, siteID, searchText.value]);

	const handleChangeSearchText = useCallback(newValue => {
		searchText.value = newValue
	}, [])

	return {
		brandOptions: brandsOptions.value.filter(op => searchText.value ? true : !excluded.includes(op.productID)),
		allBrandOptions: brandsOptions.value,
		isLoading: isLoading.value,
		searchText: searchText.value,

		handleChangeSearchText
	}
}
